import i18next from 'i18next';
import Types from '../constants/cities';
import store from '../store';
import CitiesService from './../services/cities.service';
import { reloadTable } from './AsyncTable';
import { combineLanguages } from './languages';
import { closeRequestModal } from './modals';
import { getError, getErrorNotification } from './toast';

async function ChangeCityPrice(data) {
    try {
        const res = await CitiesService.ChangeCityPrice({
            avg_price: +data.avg_price,
        });
        GetCurrentPrice()(store.dispatch, store.getState);
        return res;
    } catch (error) {
        getErrorNotification(
            i18next.t('payments.min_price_alert', {
                price: Number(data.min_price),
            })
        );
    }
}

async function PostFranchPrices({ code, data, minValue }) {
    let res;
    switch (code) {
        case 'avg_price_online':
            res = await CitiesService.PostFranchPriceOnline(data);
            break;
        case 'avg_price_li_online':
            res = await CitiesService.PostFranchPriceOnlineLi(data);
            break;
        case 'avg_price_cube_online':
            res = await CitiesService.ChangeCubeOnlinePrice(data);
            break;
        default:
            break;
    }
    return res;
}

async function GetFranchPrices({ code }) {
    let res;
    switch (code) {
        case 'price_online':
            res = await CitiesService.GetFranchPriceOnline();
            break;
        case 'price_li_online':
            res = await CitiesService.GetFranchPriceOnlineLi();
            break;
        case 'price_cube_online':
            res = await CitiesService.GetCurrentCubeOnlinePrice();
            break;
        default:
            break;
    }
    return res;
}

function GetCurrentPrice() {
    return async (dispatch, getState) => {
        const res = await CitiesService.GetCurrentPrice();
        const { cities } = getState();

        if (res) {
            dispatch({
                type: Types.GETCITIES,
                cities: {
                    ...cities,
                    cityPrice: res.payload,
                },
            });
        }
        return res;
    };
}

async function ChangeCityLiPrice(data) {
    try {
        const res = await CitiesService.ChangeCityLiPrice(
            {
                avg_price: Number(data.avg_proce_li),
            },
            true
        );
        GetCurrentLiPrice()(store.dispatch, store.getState);
        return res;
    } catch (error) {
        getErrorNotification(
            i18next.t('payments.min_price_alert', {
                price: +data.min_price_offline_li,
            })
        );
    }
}

function GetCurrentLiPrice() {
    return async (dispatch, getState) => {
        const res = await CitiesService.GetCurrentLiPrice();
        const { cities } = getState();
        if (res) {
            dispatch({
                type: Types.GETCITIES,
                cities: {
                    ...cities,
                    liPrice: res.payload,
                },
            });
        }
        return res;
    };
}

function getCities(...args) {
    return async (dispatch, getState) => {
        try {
            const response = await CitiesService.CitiesList(...args);
            dispatch({
                type: Types.GETCITIES,
                cities: {
                    ...response.payload,
                },
            });
            return response;
        } catch (error) {
            // throw 'ERROR => GET CITIES!';
            getError(error);
        }
    };
}

function getCitiesStat(...args) {
    return async (dispatch, getState) => {
        try {
            return await CitiesService.GetCitiesStat(...args);
        } catch (e) {
            getError(e);
        }
    };
}

function addCity(data) {
    return (dispatch, getState) => {
        const request = {
            parent_id: data.parent_id,
            lang_def: {},
        };
        for (let index in data) {
            const [key, lang] = index.split('|');
            if (key && lang) {
                request[key][lang] = data[index];
            }
        }
        CitiesService.AddCity({ ...request, boss_id: data.boss_id }).then(response => {
            dispatch({
                type: Types.ADDCITY,
            });
            closeRequestModal()(dispatch, getState);
            reloadTable()(dispatch, getState);
        });
    };
}

function editCity(arr_data) {
    return (dispatch, getState) => {
        const data = structuredClone(arr_data);

        const normalized = {
            ...data,
            min_price_offline: Number(data.min_price_offline),
            min_price_online: Number(data.min_price_online),
            min_price_offline_li: Number(data.min_price_offline_li),
            min_price_online_li: Number(data.min_price_online_li),
        };
        const toString = combineLanguages(arr_data.languages);

        for (let key in normalized) {
            // eslint-disable-next-line
            if (normalized[key] === '') delete normalized[key];
        }
        if (!normalized.ar) normalized.ar = false;
        if (!normalized.book) normalized.book = false;
        if (!normalized.avg_price_show) normalized.avg_price_show = false;
        if (!normalized.avg_price_online_show) normalized.avg_price_online_show = false;
        if (!normalized.avg_price_li_show) normalized.avg_price_li_show = false;
        if (!normalized.avg_price_li_online_show) normalized.avg_price_li_online_show = false;
        if (!normalized.avg_price_cube_show) normalized.avg_price_cube_show = false;
        if (!normalized.avg_price_cube_online_show) normalized.avg_price_cube_online_show = false;
        normalized.title = toString;
        CitiesService.EditCity(normalized).then(response => {
            dispatch({
                type: Types.EDITCITY,
            });
            closeRequestModal()(dispatch, getState);
            reloadTable()(dispatch, getState);
        });
    };
}

function deleteCity(data) {
    return (dispatch, getState) => {
        CitiesService.DeleteCity(data).then(response => {
            dispatch({
                type: Types.DELETECITY,
            });
            closeRequestModal()(dispatch, getState);
            reloadTable()(dispatch, getState);
        });
    };
}

function clearSingleCity() {
    return async (dispatch, getState) => {
        dispatch({
            type: Types.GETCITIES,
            cities: {
                single: null,
            },
        });
    };
}

function getSingleCity(...data) {
    return async (dispatch, getState) => {
        const res = await CitiesService.SingleCity(...data);
        dispatch({
            type: Types.GETCITIES,
            cities: {
                single: res,
            },
        });
        return res;
    };
}

function GetCurrentCubePrice() {
    return async (dispatch, getState) => {
        const res = await CitiesService.GetCurrentCubePrice();
        const { cities } = getState();
        if (res) {
            dispatch({
                type: Types.GETCITIES,
                cities: {
                    ...cities,
                    cubePrice: res.payload,
                },
            });
        }
        return res;
    };
}

async function ChangeCityCubePrice(data) {
    const res = await CitiesService.ChangeCityCubePrice(
        {
            avg_price: Number(data.avg_price_cube),
        },
        true
    );
    GetCurrentCubePrice()(store.dispatch, store.getState);
    return res;
}

export {
    addCity,
    ChangeCityLiPrice,
    ChangeCityPrice,
    ChangeCityCubePrice,
    clearSingleCity,
    deleteCity,
    editCity,
    getCities,
    getCitiesStat,
    GetCurrentLiPrice,
    GetCurrentPrice,
    GetCurrentCubePrice,
    GetFranchPrices,
    getSingleCity,
    PostFranchPrices,
};
